import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

import StreamsService from './services/StreamsService';

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        notices: [],
        stream: {},
        content: {},
        footer: {},
    },
    getters: {
        getStateById: (state) => (type,id) => {
            return state[type][id];
        },
        getStateByIds: (state) => (type,ids) => {
            return ids.map(id => { return state[type][id]; });
        },
        getNotices: (state) => {
            return state.notices;
        },
    },
    mutations: {
        SET_STATE_BY_ID: (state, { type, id, data }) => {
            console.log(`sync set state['${type}'][${id}]`);
            state[type][id] = data;
        },
        SET_STREAM: (state, { id, data }) => {
            console.log('set stream');
            state["stream"][id] = data;
        },
        SET_CONTENT: (state, { id, data }) => {
            console.log('set content');
            state["content"][id] = data;
        },
        SET_FOOTER: (state, { id, data }) => {
            console.log('set footer');
            state["footer"][id] = data;
        },
        PUSH_NOTICE: (state, { data }) => {
            console.log('push notice');
            state.notices.push(data);
        }
    },
    actions: {
        NOTIFY: function ({commit, state}, data) {
            commit('PUSH_NOTICE', { data: data })
        },
        LOAD_STREAM: function ({ commit, state }, params) {
            return new Promise((resolve, reject) => {
                StreamsService
                .getStream(params)
                .then((response) => {
                    commit('SET_STATE_BY_ID', { type:"stream", ...params, data: response.data });
                    resolve(response);
                }, error => {
                    commit('PUSH_NOTICE', { data: error.response.data })
                    reject(error);
                });
            });
        },
        LOAD_STREAMS: function ({ commit, state }, params) {
            var promises = params.ids.map (id => {
                return this.dispatch('LOAD_STREAM', { id:id, ...params });
            });
            return Promise.all(promises);
        },
        LOAD_CONTENT: function ({ commit, state}, params) {
            return new Promise((resolve, reject) => {
                StreamsService
                .getContent(params)
                .then((response) => {
                    commit('SET_STATE_BY_ID', {type:"content", ...params, data: response.data });
                    resolve(response);
                }, error => {
                    commit('PUSH_NOTICE', { data: error.response.data })
                    reject(error);
                });
            });
        },
        LOAD_FOOTER: function ({ commit, state}, params) {
            return new Promise((resolve, reject) => {
                StreamsService
                .getContent(params)
                .then((response) => {
                    commit('SET_STATE_BY_ID', {type:"footer", ...params, data: response.data });
                    resolve(response);
                }, error => {
                    console.log(error);
                    commit('PUSH_NOTICE', { data: error.response })
                    reject(error);
                });
            });
        },
        LOAD_HTML: function ({ commit, state}, {type, id, name} ) {
            console.log('Action LOAD_HTML '+{type, id, name});
            return new Promise((resolve, reject) => {
                StreamsService
                .getContent({ id, name })
                .then((response) => {
                    commit('SET_STATE_BY_ID', {...{type, id, name}, data: response.data });
                    resolve(response);
                }, error => {
                    console.log(error);
                    commit('PUSH_NOTICE', { data: error })
                    reject(error);
                });
            });
        }
    }
});



// WEBPACK FOOTER //
// ./src/store.js